import { render, staticRenderFns } from "./TriangleMenuIcon.vue?vue&type=template&id=3c0bba9a&scoped=true"
import script from "./TriangleMenuIcon.vue?vue&type=script&lang=ts"
export * from "./TriangleMenuIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0bba9a",
  null
  
)

export default component.exports